import { put } from "redux-saga/effects";
import { setTrailerData } from "../../actions/trailerAction";
// import fetchAPIServices from "../../../services/fetchAPIServices";
// import { loginApi } from "../../../services/endPoints";
import manifestTrailerData from "../../../mockdata/Firebase-formats/maniFestTrailers";

export function* handleTrailerList(action: any) {
  try {
    // const { fetchLogin } = fetchAPIServices;
    // const response = yield fetchLogin(loginApi, action.payload);

    const response = manifestTrailerData;
    if (response) {
      yield put(setTrailerData(response));
    } else {
      yield put(setTrailerData({}));
    }
  } catch (error) {
    console.log(error);
  }
}
